import React, { useEffect, useState } from "react";
import cogoToast from "cogo-toast";
import httpRequest from "../../../../ajax";
import CustomButton from "../../../../components/CustomButton";
import {
  FaEye,
  FaEyeSlash,
  FaCopy,
  FaCode,
  FaBook,
  FaKey,
} from "react-icons/fa";
import Loader from "react-loader-spinner";

const Developer = () => {
  const [developerAccess, setDeveloperAccess] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    purpose: "",
    contact_email: "",
    project_description: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(true);
  const [requestPending, setRequestPending] = useState(false);

  // New state for API key interface
  const [showApiKey, setShowApiKey] = useState(false);
  const [regeneratingKey, setRegeneratingKey] = useState(false);
  const [selectedEnvironment, setSelectedEnvironment] = useState("test");
  const [pageLoading, setPageLoading] = useState(false);
  const [userApiKey, setUserApiKey] = useState("");

  useEffect(() => {
    setLoading(true);
    httpRequest("get", "/settings/profile")
      .then(({ data: { data } }) => {
        setDeveloperAccess(data[0]?.developerAccess || "");
        setUserApiKey(data[0]?.api_key || "");
        setRequestPending(data[0]?.developerAccess === "pending");
      })
      .catch(() => {
        cogoToast.error("Failed to fetch profile data");
      })
      .finally(() => setLoading(false));
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await httpRequest("post", "/verification/developer-api", formData);
      cogoToast.success(
        "Your request has been received and our team will reach out to you. Check back to see your access."
      );
      setRequestPending(true);
      setShowForm(false);
      setFormData({
        purpose: "",
        contact_email: "",
        project_description: "",
      });
    } catch (error) {
      cogoToast.error("Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  const handleCopyApiKey = () => {
    navigator.clipboard.writeText(userApiKey);
    cogoToast.success("API Key copied to clipboard!");
  };

  const handleCopyCode = (code) => {
    navigator.clipboard.writeText(code);
    cogoToast.success("Code copied to clipboard!");
  };

  const handleRegenerateApiKey = () => {
    setRegeneratingKey(true);
    setTimeout(() => {
      cogoToast.success("API Key regenerated successfully!");
      setRegeneratingKey(false);
    }, 2000);
  };

  if (loading) return <p className="text-center mt-5">Loading...</p>;

  if (requestPending) {
    return (
      <div className="text-center mt-5">
        <h4>Your Developer Access request is pending approval</h4>
        <p>Our team will review your request and get back to you soon.</p>
      </div>
    );
  }

  if (!developerAccess) {
    return (
      <div className="developer-section container py-4">
        <div className="card mx-auto" style={{ maxWidth: "600px" }}>
          <div className="card-body text-center">
            <h4 className="mb-3">Click Here to request Developer Access</h4>

            {!showForm && !requestPending && (
              <CustomButton
                text="Request Here"
                backgroundColor="#3A6ED4"
                color="#fff"
                handleClick={() => setShowForm(true)}
              />
            )}

            {showForm && (
              <form className="mt-4 text-left" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>Purpose</label>
                  <input
                    type="text"
                    name="purpose"
                    value={formData.purpose}
                    onChange={handleInputChange}
                    className="form-control"
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Contact Email</label>
                  <input
                    type="email"
                    name="contact_email"
                    value={formData.contact_email}
                    onChange={handleInputChange}
                    className="form-control"
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Project Description</label>
                  <textarea
                    name="project_description"
                    value={formData.project_description}
                    onChange={handleInputChange}
                    className="form-control"
                    rows="4"
                    required
                  />
                </div>

                <CustomButton
                  text={submitting ? "Submitting..." : "Submit Request"}
                  backgroundColor="#28a745"
                  color="#fff"
                  type="submit"
                  disabled={submitting}
                />
              </form>
            )}
          </div>
        </div>
      </div>
    );
  }

  // API configurations for approved developers
  const environments = {
    test: "https://test.workbrook.us",
    live: "https://workbrook.us",
  };

  const apiEndpoint = `${environments[selectedEnvironment]}/api/v2/business/jobs/create`;

  const requestBody = {
    campany_name: "Dev244 Test",
    industry: "Building",
    about_company: "Good Company description",
    no_of_staff: "10 - 15",
    job_level: 1,
    role_title: "Developer",
    job_type: "Full Time",
    reports_to: "Line Manager",
    applicant_benefit: "Great benefits package",
    skills_required: ["Active learning", "JavaScript", "React"],
    location: "Abuja",
    additional_files: [
      "https://example.com/job-description.pdf",
      "https://example.com/company-brochure.pdf",
    ],
    isCompanyRepresentative: 1,
    isToRefTimeLineOrToHireRecruter: 1,
    refererIdOne: 1,
    refererIdTwo: 2,
    canRecruiterRequest: 1,
    country: 22,
    salary: "5000",
    salary_range: "200 - 500",
    duration: "Monthly",
    job_tier: 2,
    estimated_views: 100,
    external_platforms: ["linkedin", "indeed"],
  };

  const responseExample = {
    status: true,
    data: {
      campany_name: "Dev244 Test",
      industry: "Building",
      about_company: "Goog Companyfwfwe",
      no_of_staff: "10 - 15",
      job_level: {
        id: "1",
        title: "Executive",
      },
      role_title: "Developer",
      job_type: "Full Time",
      reports_to: "Line Mgr",
      applicant_benefit: "story",
      skills_required: ["Active learning"],
      location: "Abuja",
      additional_files: ["Link1", "Link1", "Link1"],
      isCompanyRepresentative: 1,
      isToRefTimeLineOrToHireRecruter: 1,
      canRecruiterRequest: 1,
      country: 22,
      salary: "5000",
      duration: "",
      job_tier: 2,
      estimated_views: 100,
      external_platforms: '["linkedin"]',
      views_left: "100",
      external_platform_results: {
        linkedin: {
          success: false,
          error: "Failed to obtain LinkedIn access token",
        },
      },
    },
    message: "Job added successfully",
  };

  const errorResponseExample = {
    success: false,
    message: "Validation failed",
    errors: {
      campany_name: "Company name is required",
      role_title: "Role title is required",
    },
  };

  const curlExample = `curl -X POST "${apiEndpoint}" \\
  -H "Content-Type: application/json" \\
  -H "Authorization: Bearer ${userApiKey}" \\
  -d '${JSON.stringify(requestBody, null, 2)}'`;

  const javascriptExample = `const response = await fetch('${apiEndpoint}', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ${userApiKey}'
  },
  body: JSON.stringify(${JSON.stringify(requestBody, null, 2)})
});

const result = await response.json();
console.log(result);`;

  const pythonExample = `import requests
import json

url = "${apiEndpoint}"
headers = {
    "Content-Type": "application/json",
    "Authorization": "Bearer ${userApiKey}"
}
data = ${JSON.stringify(requestBody, null, 2)}

response = requests.post(url, headers=headers, data=json.dumps(data))
result = response.json()
print(result)`;

  // Return the full developer interface for approved users
  return (
    <div className="developer-section" style={{ overflowX: "hidden" }}>
      {pageLoading && (
        <Loader type="ThreeDots" color="#3A6ED4" height={100} width={100} />
      )}
      <div className="d-flex align-items-center mb-4">
        <FaCode className="mr-2" size={24} color="#3A6ED4" />
        <h2 className="mb-0">Developer API</h2>
      </div>

      <p className="text-muted mb-4">
        Use our API to programmatically create job posts on the workbrook
        platform. Integrate job posting directly into your systems and
        workflows.
      </p>

      {/* API Key Section */}
      <div
        className="card mb-4"
        style={{ border: "1px solid #e8e9eb", borderRadius: "8px" }}
      >
        <div className="card-header bg-light d-flex flex-column flex-md-row align-items-md-center justify-content-between">
          <div className="d-flex align-items-center mb-2 mb-md-0">
            <FaKey className="mr-2" color="#3A6ED4" />
            <h5 className="mb-0">API Key</h5>
          </div>
          <CustomButton
            text={regeneratingKey ? "Regenerating..." : "Regenerate Key"}
            backgroundColor="#dc3545"
            color="#fff"
            additionalClass="btn-sm"
            handleClick={handleRegenerateApiKey}
            disabled={regeneratingKey}
          />
        </div>
        <div className="card-body">
          <p className="text-muted mb-3">
            Your API key is used to authenticate requests. Keep it secure and
            don&apos;t share it publicly.
          </p>
          <div className="d-flex flex-column flex-md-row align-items-md-center">
            <div className="flex-grow-1 mb-2 mb-md-0 mr-md-3">
              <div className="input-group">
                <input
                  type={showApiKey ? "text" : "password"}
                  className="form-control"
                  value={userApiKey}
                  readOnly
                  style={{
                    backgroundColor: "#f8f9fa",
                    fontFamily: "monospace",
                    fontSize: "12px",
                  }}
                />
                <div className="input-group-append">
                  <button
                    className="btn btn-outline-secondary"
                    type="button"
                    onClick={() => setShowApiKey(!showApiKey)}
                  >
                    {showApiKey ? <FaEyeSlash /> : <FaEye />}
                  </button>
                  <button
                    className="btn btn-primary"
                    type="button"
                    onClick={handleCopyApiKey}
                  >
                    <FaCopy className="mr-1" />
                    Copy
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* API Documentation */}
      <div
        className="card mb-4"
        style={{ border: "1px solid #e8e9eb", borderRadius: "8px" }}
      >
        <div className="card-header bg-light d-flex align-items-center">
          <FaBook className="mr-2" color="#3A6ED4" />
          <h5 className="mb-0">API Documentation</h5>
        </div>
        <div className="card-body">
          <div className="mb-4">
            <label htmlFor="environment-select" className="form-label">
              <h6>Select Environment</h6>
            </label>
            <select
              id="environment-select"
              className="form-control"
              value={selectedEnvironment}
              onChange={(e) => setSelectedEnvironment(e.target.value)}
            >
              <option value="test">Test Environment</option>
              <option value="live">Live Environment</option>
            </select>
          </div>
          {/* Endpoint */}
          <div className="mb-4">
            <h6>Endpoint</h6>
            <div
              className="bg-light p-3 rounded"
              style={{ border: "1px solid #dee2e6" }}
            >
              <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between">
                <div className="d-flex flex-column flex-md-row align-items-md-center flex-grow-1 mb-2 mb-md-0">
                  <code className="text-success font-weight-bold mr-md-3 mb-1 mb-md-0">
                    POST
                  </code>
                  <code
                    className="flex-grow-1"
                    style={{
                      wordBreak: "break-all",
                      overflowWrap: "break-word",
                      fontSize: "12px",
                    }}
                  >
                    {apiEndpoint}
                  </code>
                </div>
                <button
                  className="btn btn-sm btn-outline-primary"
                  onClick={() => handleCopyCode(apiEndpoint)}
                >
                  <FaCopy />
                </button>
              </div>
            </div>
          </div>

          {/* Authentication */}
          <div className="mb-4">
            <h6>Authentication</h6>
            <p className="text-muted">
              Include your API key in the Authorization header:
            </p>
            <div
              className="bg-light p-3 rounded"
              style={{ border: "1px solid #dee2e6" }}
            >
              <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between">
                <code
                  className="flex-grow-1 mb-2 mb-md-0"
                  style={{
                    wordBreak: "break-all",
                    overflowWrap: "break-word",
                    fontSize: "12px",
                  }}
                >
                  Authorization: Bearer YOUR_API_KEY
                </code>
                <button
                  className="btn btn-sm btn-outline-primary"
                  onClick={() =>
                    handleCopyCode("Authorization: Bearer YOUR_API_KEY")
                  }
                >
                  <FaCopy />
                </button>
              </div>
            </div>
          </div>

          {/* Request Body */}
          <div className="mb-4">
            <h6>Request Body</h6>
            <p className="text-muted">
              Send a JSON object with the following fields:
            </p>
            <div
              className="bg-light p-3 rounded position-relative"
              style={{ border: "1px solid #dee2e6" }}
            >
              <button
                className="btn btn-sm btn-outline-primary position-absolute"
                style={{
                  top: "10px",
                  right: "10px",
                  zIndex: 1,
                }}
                onClick={() =>
                  handleCopyCode(JSON.stringify(requestBody, null, 2))
                }
              >
                <FaCopy />
              </button>
              <pre
                style={{
                  fontSize: "11px",
                  marginBottom: 0,
                  paddingRight: "50px",
                  overflowX: "auto",
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                }}
              >
                <code>{JSON.stringify(requestBody, null, 2)}</code>
              </pre>
            </div>
          </div>

          {/* Field Descriptions */}
          <div className="mb-4">
            <h6>Field Descriptions</h6>
            <div className="table-responsive">
              <table className="table table-sm table-bordered">
                <thead className="thead-light">
                  <tr>
                    <th>Field</th>
                    <th>Type</th>
                    <th>Required</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <code>campany_name</code>
                    </td>
                    <td>string</td>
                    <td>Yes</td>
                    <td>Name of the company</td>
                  </tr>
                  <tr>
                    <td>
                      <code>industry</code>
                    </td>
                    <td>string</td>
                    <td>Yes</td>
                    <td>Industry category</td>
                  </tr>
                  <tr>
                    <td>
                      <code>about_company</code>
                    </td>
                    <td>string</td>
                    <td>Yes</td>
                    <td>Company description</td>
                  </tr>
                  <tr>
                    <td>
                      <code>no_of_staff</code>
                    </td>
                    <td>string</td>
                    <td>No</td>
                    <td>Company size range</td>
                  </tr>
                  <tr>
                    <td>
                      <code>job_level</code>
                    </td>
                    <td>number</td>
                    <td>Yes</td>
                    <td>Job level (1-5)</td>
                  </tr>
                  <tr>
                    <td>
                      <code>role_title</code>
                    </td>
                    <td>string</td>
                    <td>Yes</td>
                    <td>Job title</td>
                  </tr>
                  <tr>
                    <td>
                      <code>job_type</code>
                    </td>
                    <td>string</td>
                    <td>Yes</td>
                    <td>Employment type</td>
                  </tr>
                  <tr>
                    <td>
                      <code>skills_required</code>
                    </td>
                    <td>array</td>
                    <td>No</td>
                    <td>List of required skills</td>
                  </tr>
                  <tr>
                    <td>
                      <code>location</code>
                    </td>
                    <td>string</td>
                    <td>Yes</td>
                    <td>Job location</td>
                  </tr>
                  <tr>
                    <td>
                      <code>salary_range</code>
                    </td>
                    <td>string</td>
                    <td>No</td>
                    <td>Salary range</td>
                  </tr>
                  <tr>
                    <td>
                      <code>external_platforms</code>
                    </td>
                    <td>array</td>
                    <td>No</td>
                    <td>Third-party platforms to post to</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Success Response */}
          <div className="mb-4">
            <h6>Success Response (200 OK)</h6>
            <div
              className="bg-light p-3 rounded position-relative"
              style={{ border: "1px solid #dee2e6" }}
            >
              <button
                className="btn btn-sm btn-outline-primary position-absolute"
                style={{
                  top: "10px",
                  right: "10px",
                  zIndex: 1,
                }}
                onClick={() =>
                  handleCopyCode(JSON.stringify(responseExample, null, 2))
                }
              >
                <FaCopy />
              </button>
              <pre
                style={{
                  fontSize: "11px",
                  marginBottom: 0,
                  paddingRight: "50px",
                  overflowX: "auto",
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                }}
              >
                <code>{JSON.stringify(responseExample, null, 2)}</code>
              </pre>
            </div>
          </div>

          {/* Error Response */}
          <div className="mb-4">
            <h6>Error Response (400 Bad Request)</h6>
            <div
              className="bg-light p-3 rounded position-relative"
              style={{ border: "1px solid #dee2e6" }}
            >
              <button
                className="btn btn-sm btn-outline-primary position-absolute"
                style={{
                  top: "10px",
                  right: "10px",
                  zIndex: 1,
                }}
                onClick={() =>
                  handleCopyCode(JSON.stringify(errorResponseExample, null, 2))
                }
              >
                <FaCopy />
              </button>
              <pre
                style={{
                  fontSize: "11px",
                  marginBottom: 0,
                  paddingRight: "50px",
                  overflowX: "auto",
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                }}
              >
                <code>{JSON.stringify(errorResponseExample, null, 2)}</code>
              </pre>
            </div>
          </div>
        </div>
      </div>

      {/* Code Examples */}
      <div
        className="card"
        style={{ border: "1px solid #e8e9eb", borderRadius: "8px" }}
      >
        <div className="card-header bg-light">
          <h5 className="mb-0">Code Examples</h5>
        </div>
        <div className="card-body">
          {/* cURL Example */}
          <div className="mb-4">
            <h6>cURL</h6>
            <div className="bg-dark text-light p-3 rounded position-relative">
              <button
                className="btn btn-sm btn-outline-light position-absolute"
                style={{
                  top: "10px",
                  right: "10px",
                  zIndex: 1,
                }}
                onClick={() => handleCopyCode(curlExample)}
              >
                <FaCopy />
              </button>
              <pre
                style={{
                  fontSize: "11px",
                  marginBottom: 0,
                  paddingRight: "50px",
                  color: "#f8f9fa",
                  overflowX: "auto",
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                }}
              >
                <code>{curlExample}</code>
              </pre>
            </div>
          </div>

          {/* JavaScript Example */}
          <div className="mb-4">
            <h6>JavaScript (Fetch)</h6>
            <div className="bg-dark text-light p-3 rounded position-relative">
              <button
                className="btn btn-sm btn-outline-light position-absolute"
                style={{
                  top: "10px",
                  right: "10px",
                  zIndex: 1,
                }}
                onClick={() => handleCopyCode(javascriptExample)}
              >
                <FaCopy />
              </button>
              <pre
                style={{
                  fontSize: "11px",
                  marginBottom: 0,
                  paddingRight: "50px",
                  color: "#f8f9fa",
                  overflowX: "auto",
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                }}
              >
                <code>{javascriptExample}</code>
              </pre>
            </div>
          </div>

          {/* Python Example */}
          <div className="mb-4">
            <h6>Python (Requests)</h6>
            <div className="bg-dark text-light p-3 rounded position-relative">
              <button
                className="btn btn-sm btn-outline-light position-absolute"
                style={{
                  top: "10px",
                  right: "10px",
                  zIndex: 1,
                }}
                onClick={() => handleCopyCode(pythonExample)}
              >
                <FaCopy />
              </button>
              <pre
                style={{
                  fontSize: "11px",
                  marginBottom: 0,
                  paddingRight: "50px",
                  color: "#f8f9fa",
                  overflowX: "auto",
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                }}
              >
                <code>{pythonExample}</code>
              </pre>
            </div>
          </div>
        </div>
      </div>

      {/* Rate Limiting Info */}
      <div className="alert alert-info mt-4">
        <strong>Rate Limiting:</strong> This API is rate limited to 100 requests
        per hour per API key. If you exceed this limit, you&apos;ll receive a
        429 (Too Many Requests) response.
      </div>

      {/* Support Info */}
      <div className="alert alert-light mt-3">
        <strong>Need Help?</strong> If you have questions about the API or need
        support with integration, please contact our developer support team at{" "}
        <a href="mailto:developer@workbrook.com">developer@workbrook.com</a>
      </div>
    </div>
  );
};

export default Developer;
